module.exports = __webpack_public_path__ + "static/media/ihover.24f1425e.png";